import styled from 'styled-components';

export const ConditionMainWrapper = styled.div`
  width: 100%;
  & > div:first-child {
    display: flex;
    justify-content: space-between;
    margin: 16px 0;
  }
`;

export const GeneralConditionRowContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  column-gap: 20px;
  width: 100%;
  .suffix-selector-input {
    padding: 0;
    .ant-input {
      padding: 8px 11px;
      border-radius: 4px 0 0 4px;
      border: none;
    }
    .ant-input-group-addon {
      background-color: ${({ theme }) => theme.colors.primary.white};
      border: none;
      ::before {
        content: ' ';
        height: 20px;
        left: 0;
        bottom: auto;
        top: 8px;
        position: absolute;
        width: 1px;
        background: #cfd4dd;
      }
    }
  }
`;

export const ContractListWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const DeleteContainer = styled.div`
  display: flex;
  gap: 20px;
  align-items: center;
  .remove-icon {
    height: 40px;
    margin-top: 4px;
    cursor: pointer;
  }
`;

export const ItemsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  gap: 20px;
`;
